<template>
  <div class="cloud-experiments-banner-wrapper">
      <component :is="cloudBanners"></component>
  </div>
</template>

<script>
import CloudBannerB from '@/components/banners/CloudBannerB.vue'
import CloudBannerA from '@/components/banners/CloudBannerA.vue'
import {
  EXPERIMENT_CLOUD_KEY_NAME,
  EXPERIMENT_GROUP_NAME_A,
  EXPERIMENT_GROUP_NAME_B
} from '@/constants/experiments'

export default {
  name: 'CloudExperimentsBannerWrapper',

  components: {
    CloudBannerB,
    CloudBannerA
  },

  props: {
    experimentData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      EXPERIMENT_GROUP_NAME_A,
      EXPERIMENT_GROUP_NAME_B
    }
  },

  computed: {
    cloudBanners() {
      switch (this.experimentData.group) {
        case EXPERIMENT_GROUP_NAME_A:
          return CloudBannerA
        case EXPERIMENT_GROUP_NAME_B:
          return CloudBannerB
        default:
          return CloudBannerA
      }
    }
  },

  mounted() {
    this.$store.dispatch('experiments/setVisited', EXPERIMENT_CLOUD_KEY_NAME)
  }
}
</script>

<style>
.cloud-experiments-banner-wrapper {
  width: 100%;
}
</style>